import React from 'react';

export default function EnabledCheckMark() {
  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path d="M7.526 15.053A7.526 7.526 0 107.526 0a7.526 7.526 0 000 15.053z" fill="#00BF6F" fillRule="nonzero" />
        <path
          d="M4.704 8.146l2.33 3.002 4.274-5.503"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.468"
        />
      </g>
    </svg>
  );
}
